import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Rootstate } from '../../store';
import { useDispatch } from 'react-redux';
import { toggleLayer } from '../../reducers/map/mapReducerActions';
import DMIcon from '../Icons/DmIcon';

const DmLayerEditor = () => {
    const { currentLayer } = useSelector((state: Rootstate) => ({
        currentLayer: state.map.mainLayer,
    }), shallowEqual);

    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(toggleLayer());
    };

    return (
        <div
            className={
                'flex items-center cursor-pointer justify-center h-16 min-w-18 rounded-bl-xl rounded-tl-xl'
                + ` ${currentLayer === 'dm' ? 'bg-mid-blue' : ''}`}
            onClick={handleClick}
        >
            <div className="pl-2 pr-2 ">
                <DMIcon className="h-7" />
            </div>
        </div>
    );
};

export default DmLayerEditor;
